'use client'

import {FC, PropsWithChildren} from 'react'

import {AcademyHeader} from '@/components/academy/header/AcademyHeader'
import {Sidebar} from '@/components/academy/sidebar/Sidebar'
import {Section} from '@/components/common/content/Section'
import {Page} from '@/components/Page'
import {theme} from '@/theme/theme'
import {AcademyContents} from '@/utils/contentful'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type ArticleLayoutProps = {
  contents: AcademyContents
}

const ArticleLayout: FC<PropsWithChildren<ArticleLayoutProps>> = ({contents, children}) => (
  <>
    <Page header={<AcademyHeader contents={contents} />}>
      <Section>
        <div className="wrapper">
          <aside className="sidebar">
            <Sidebar contents={contents} />
          </aside>
          <div className="content">{children}</div>
        </div>
      </Section>
    </Page>

    <style jsx>{`
      .wrapper {
        display: flex;
      }

      .sidebar {
        flex: 0 0 300px;
        background-color: ${theme.palette.background.default};
        border-right: 1px solid ${theme.palette.gray[200]};
        padding: ${theme.spacing[8]} ${theme.spacing[6]} ${theme.spacing[8]} 0;
      }

      .content {
        padding: ${theme.spacing[8]} 0 ${theme.spacing[8]} ${theme.spacing[6]};
      }

      @media ${TABLET_SCREENSIZE} {
        .sidebar {
          display: none;
        }

        .content {
          padding: ${theme.spacing[7]} 0;
        }
      }

      @media ${MOBILE_SCREENSIZE} {
        .content {
          padding: ${theme.spacing[5]} 0 ${theme.spacing[6]};
        }
      }
    `}</style>
  </>
)

export default ArticleLayout
